import { Check, CheckCheck, X } from 'lucide-react';

import { StatusPill } from '@/components/ui/status-pill';
import { cn } from '@/lib/utils';
import type { FloorPlanTierContent } from './floorPlanTierContent';

interface FloorPlanFeatureChipsProps {
  content: FloorPlanTierContent;
  /** Stacked on a card, wrapped in a row in the example dialog. */
  layout: 'stack' | 'wrap';
}

/** A tier's "Everything in …" chip, then what it does and does not include. */
export function FloorPlanFeatureChips({
  content,
  layout
}: FloorPlanFeatureChipsProps) {
  return (
    <ul
      className={cn(
        'flex gap-1.5',
        layout === 'stack' ? 'flex-col items-start' : 'flex-wrap'
      )}
    >
      {content.inherits && (
        <li>
          <StatusPill variant="success" icon={CheckCheck}>
            {content.inherits}
          </StatusPill>
        </li>
      )}
      {content.features.map((feature) => (
        <li key={feature.label}>
          <StatusPill
            variant={feature.included ? 'success' : 'muted'}
            icon={feature.included ? Check : X}
          >
            <span className="sr-only">
              {feature.included ? 'Includes ' : 'Does not include '}
            </span>
            {feature.label}
          </StatusPill>
        </li>
      ))}
    </ul>
  );
}
